import { ChangeDetectionStrategy, Component, input, output, signal, viewChild } from '@angular/core';

import { NoxoIconButton } from '@noxo/ui/button';
import { NoxoDialog, NoxoDialogHeader } from '@noxo/ui/dialog';
import { NoxoIcon } from '@noxo/ui/icon';

@Component({
  selector: 'noxo-demo-panel',
  imports: [NoxoDialog, NoxoDialogHeader, NoxoIcon, NoxoIconButton],
  template: `
    <dialog
      noxo-dialog
      placement="side"
      [attr.aria-label]="heading()"
      (close)="closed()">
      <noxo-dialog-header>
        <hgroup>
          <h2>{{ heading() }}</h2>
          <p>{{ caption() }}</p>
        </hgroup>
        <button
          type="button"
          noxo-icon-button
          shape="round"
          aria-label="Close"
          (click)="close()">
          <noxo-icon icon="xmark" />
        </button>
      </noxo-dialog-header>
      <ng-content />
    </dialog>
  `,
  styleUrls: ['./demo-contents.scss', './demo-heading.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoPanel {
  private readonly dialog = viewChild.required(NoxoDialog);

  public readonly heading = input.required<string>();
  public readonly caption = input('');
  public readonly dismissed = output();
  public readonly isOpen = signal(false);

  public open(): void {
    this.isOpen.set(true);
    this.dialog().showModal();
  }

  public close(): void {
    this.dialog().close();
  }

  protected closed(): void {
    this.isOpen.set(false);
    this.dismissed.emit();
  }
}
